// src/pages/onboarding/OnboardingPage.tsx - Onboarding welcome page

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Box, 
  Typography, 
  Button, 
  Paper,
  Stack
} from '@mui/material';
import { theme } from '../../theme';

const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  
  const handleStartAssessment = () => {
    navigate('/assessment');
  };
  
  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
          Welcome to Inner Ops
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 4, fontStyle: 'italic' }}>
          Clarity Over Comfort
        </Typography>
        
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
            Your Journey Begins Here
          </Typography>
          
          <Typography variant="body1" paragraph>
            Inner Ops is a tactical system designed for high-performance men reclaiming their power, discipline, and purpose. This is not self-help fluff—it's a battlefield app for men at war with themselves.
          </Typography>
          
          <Typography variant="body1" paragraph>
            To get started, we'll create your Inner Ops Profile through a brief assessment. This will help us understand your:
          </Typography>
          
          <Stack spacing={1} sx={{ mb: 3, pl: 2 }}>
            <Typography variant="body1">• Core values that drive you</Typography>
            <Typography variant="body1">• Pain points and challenges you face</Typography>
            <Typography variant="body1">• Life themes that define your journey</Typography>
            <Typography variant="body1">• Areas where you seek clarity and control</Typography>
          </Stack>
          
          <Typography variant="body1" paragraph>
            This profile will be your foundation for tracking progress, identifying patterns, and building a system of clarity and discipline.
          </Typography>
          
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleStartAssessment}
              sx={{ py: 1.5, px: 4 }}
            >
              Start Assessment
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default OnboardingPage;
